export enum PromoCodeStatus {
  NOT_SET = 0,
  PLANNING = 1,
  UPCOMING = 2,
  ACTIVE = 3,
  EXPIRED = 4,
  CANCELLED = 5,
}
